import { Grid, useMediaQuery } from "@mui/material";
import { endlessOfferAssets } from "assets/cdn";
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { useWebStoreContext } from "contexts";
import { useAppDispatch, useImagePath } from "hooks";
import { EndlessOfferResponse } from "interfaces/endless-offer";
import { featureTrackerAPI } from "redux/apis";
import { onClosePopUp } from "redux/slices";
import {
	Body,
	Button,
	Container,
	Header,
	HeaderBackground,
	HeaderTitle,
	PalmTrees,
	Title
} from "./styles";

interface EndlessOfferRewardProps {}

export const EndlessOfferReward: React.FC<EndlessOfferRewardProps> = () => {
	const dispatch = useAppDispatch();
	const { getImage } = useImagePath("cdn");
	const { authToken } = useWebStoreContext();

	const { data }: { data?: EndlessOfferResponse } =
		featureTrackerAPI.endpoints.getFeatureTracker.useQueryState({
			FeatureType: "endless-offer",
			isAuthenticated: !!authToken?.value
		});

	const headImageUrl =
		data?.tracker?.themeConfig?.popupImageUrl ??
		getImage(endlessOfferAssets.popup.background);
	const palmTreesImgUrl = getImage(
		endlessOfferAssets.popup.backgroundPalmTrees
	);
	const titleUrl = getImage(endlessOfferAssets.popup.title);
	const isPortrait = useMediaQuery("(orientation: portrait)");
	const scale = useCalculateScale(378, 380);

	const onClose = () => {
		dispatch(
			featureTrackerAPI.util.invalidateTags([
				{
					type: "featureTrackerTag",
					id: "endless-offer"
				}
			])
		);
		dispatch(onClosePopUp());
	};

	return (
		<Container scale={scale}>
			<CloseIconButton onClose={onClose} />
			<Header>
				<HeaderBackground src={headImageUrl} alt="" />
				{!data?.tracker?.themeConfig && (
					<>
						<PalmTrees data-image={palmTreesImgUrl} />
						<HeaderTitle src={titleUrl} />
					</>
				)}
			</Header>
			<Body>
				<Title>
					Your items are waiting in your in-game inbox to be collected!
				</Title>

				<Grid container spacing={isPortrait ? 2 : 1}>
					<Grid
						item
						xs={12}
						//xs={isMobile ? 6 : 12}
						//sm={isMobile ? 6 : 12}
						display="flex"
						justifyContent="center"
					>
						<Button
							variant="contained"
							themeColor="secondary"
							sx={{ minWidth: { xs: "100%", sm: "100%" } }}
							onClick={() => onClose()}
						>
							Continue Shopping
						</Button>
					</Grid>
					{/* {isMobile && (
						<Grid item xs={6} sm={6} display="flex" justifyContent="center">
							<BackToGameButton
								source="endless_offer_dialog"
								themeColor="secondary"
								sx={{ minWidth: { xs: "100%", sm: "100%" } }}
							/>
						</Grid>
					)} */}
				</Grid>
			</Body>
		</Container>
	);
};
